import React from 'react';

function GifIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-167 -2541)">
          <g transform="translate(136 2375)">
            <g transform="translate(31 166)">
              <path d="M12.25 20.708a.292.292 0 00-.292-.291H9.333A2.333 2.333 0 017 18.083v-1.75c0-.322.261-.583.583-.583h4.375c.161 0 .292-.13.292-.292v-1.166a.292.292 0 00-.292-.292H7.583A.583.583 0 017 13.417V9.333c0-.322.261-.583.583-.583h8.167c.322 0 .583.261.583.583v2.625c0 .161.13.292.292.292h2.917c.16 0 .291-.13.291-.292V4.667A4.667 4.667 0 0015.167 0h-14a1.167 1.167 0 100 2.333A2.333 2.333 0 013.5 4.667v13.416a4.667 4.667 0 004.667 4.667h3.791c.161 0 .292-.13.292-.292v-1.75zm4.083-14.291A.583.583 0 0115.75 7H7.583A.583.583 0 017 6.417v-3.5c0-.322.261-.584.583-.584H14a2.333 2.333 0 012.333 2.334v1.75z" />
              <path d="M28 15.75A1.75 1.75 0 0026.25 14h-10.5A1.75 1.75 0 0014 15.75v10.5c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0028 26.25v-10.5zm-4.625 6.183l-3.634 2.124a1.099 1.099 0 01-1.658-.934v-4.246a1.1 1.1 0 011.66-.934l3.634 2.124a1.078 1.078 0 01-.002 1.866z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default GifIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/Gif.js